import { languages, findSupportedLanguageTag } from '@logto/language-kit';
import { z } from 'zod';
import en from './locales/en/index.js';
// Các locale gốc của Logto (ar, cs, de, es, es-mx, fa-ir, fr, it, ja, ko, pl-pl, pt-br, pt-pt, ru,
// th, tr-tr, uk-ua, zh-cn, zh-hk, zh-tw) vẫn còn file dịch trên đĩa nhưng KHÔNG import/expose ở
// đây — sdvico chỉ hỗ trợ 2 chế độ ngôn ngữ: English / Tiếng Việt. Khôi phục dễ dàng khi cần.
import viVN from './locales/vi-vn/index.js';
export const builtInLanguages = ['en', 'vi-VN'];
export const builtInLanguageOptions = builtInLanguages.map((languageTag) => ({
    value: languageTag,
    title: languages[languageTag],
}));
export const builtInLanguageTagGuard = z.enum(builtInLanguages);
const resource = {
    en,
    'vi-VN': viVN,
};
export const getDefaultLanguageTag = (language) => builtInLanguageTagGuard.parse(findSupportedLanguageTag(language ? [language] : [], builtInLanguages, 'en'));
export const isBuiltInLanguageTag = (language) => builtInLanguageTagGuard.safeParse(language).success;
export default resource;
